import { LocalCurrencies } from './types'

const localCurrencies: LocalCurrencies = {
  USD: {
    currency: 'USD',
    symbol: '$',
    svg: '/images/currencies/USD.svg',
  },
  EUR: {
    currency: 'EUR',
    symbol: '€',
    svg: '/images/currencies/EUR.svg',
  },
  GBP: {
    currency: 'GBP',
    symbol: '£',
    svg: '/images/currencies/GBP.svg',
  },
}

export default localCurrencies
